export const editorCorrections = function (el) {
    const els = el.querySelectorAll("figure");
    const as = el.querySelectorAll("a");
    els.forEach(function (item) {
        item.style.width = "";
        item.style.height = "";
        if (item.querySelector("img").classList.contains("size-large")) {
            item.classList.add("normal");
        } else if (item.querySelector("img").classList.contains("size-small")) {
            item.classList.add("tiny");
        } else if (
            item.querySelector("img").classList.contains("size-medium")
        ) {
            item.classList.add("small");
        }
    });
    as.forEach(function (a_item) {
        if (a_item.querySelector("img") != null) {
            return;
        }
        if (a_item.href.indexOf(site_settings.base) > -1) {
            return;
        }
        if (a_item.innerText.indexOf("↗") > -1) {
            return;
        }
        a_item.innerHTML = a_item.innerHTML + " <span class='a'>↗</span>";
    });
};
